/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const container = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100%;
`;

const infoBox = css`
  background-color: rgba(0, 0, 0, 0.6);
  padding: 30px;
  border-radius: 10px;
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
  font-size: 1rem;
  line-height: 1.6;
  
  a {
    color: #ff3333;
    text-decoration: underline;
    
    &:hover {
      color: #ff6666;
    }
  }

  @media (max-width: 768px) {
    padding: 20px;
    font-size: 0.9rem;
    max-width: 90%;
  }

  @media (max-width: 480px) {
    padding: 15px;
    font-size: 0.85rem;
    max-width: 95%;
    border-radius: 8px;
  }
`;

const Home = () => (
  <div css={container}>
    <div css={infoBox}>
      <p>More stuff coming soon. For booking & inqueries send an email to <a href="mailto:info@mamlishboys.com">info@mamlishboys.com</a></p>
    </div>
  </div>
);

export default Home;
